const  environment = {
    CLIENT_NAME: process.env.REACT_APP_CLIENT_NAME ?? "#{clientName}",
    CUSTOMER_PORTAL_API: process.env.REACT_APP_CUSTOMER_PORTAL_API ??  "#{customerPortalApi}",
    CUSTOMER_PORTAL_API_KEY: process.env.REACT_APP_CUSTOMER_PORTAL_API_KEY ?? "#{customerPortalApiKey}",
}

export default environment;